"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "en", {
  enumerable: true,
  get: function get() {
    return _en.default;
  }
});
Object.defineProperty(exports, "de", {
  enumerable: true,
  get: function get() {
    return _de.default;
  }
});
Object.defineProperty(exports, "fr", {
  enumerable: true,
  get: function get() {
    return _fr.default;
  }
});
Object.defineProperty(exports, "es", {
  enumerable: true,
  get: function get() {
    return _es.default;
  }
});
Object.defineProperty(exports, "uk", {
  enumerable: true,
  get: function get() {
    return _uk.default;
  }
});
Object.defineProperty(exports, "nl", {
  enumerable: true,
  get: function get() {
    return _nl.default;
  }
});
Object.defineProperty(exports, "tr", {
  enumerable: true,
  get: function get() {
    return _tr.default;
  }
});
Object.defineProperty(exports, "pl", {
  enumerable: true,
  get: function get() {
    return _pl.default;
  }
});
Object.defineProperty(exports, "ru", {
  enumerable: true,
  get: function get() {
    return _ru.default;
  }
});
Object.defineProperty(exports, "ja", {
  enumerable: true,
  get: function get() {
    return _ja.default;
  }
});
Object.defineProperty(exports, "hu", {
  enumerable: true,
  get: function get() {
    return _hu.default;
  }
});
Object.defineProperty(exports, "pt", {
  enumerable: true,
  get: function get() {
    return _pt.default;
  }
});
Object.defineProperty(exports, "zh_Hant", {
  enumerable: true,
  get: function get() {
    return _zh_Hant.default;
  }
});

var _en = _interopRequireDefault(require("./en"));

var _de = _interopRequireDefault(require("./de"));

var _fr = _interopRequireDefault(require("./fr"));

var _es = _interopRequireDefault(require("./es"));

var _uk = _interopRequireDefault(require("./uk"));

var _nl = _interopRequireDefault(require("./nl"));

var _tr = _interopRequireDefault(require("./tr"));

var _pl = _interopRequireDefault(require("./pl"));

var _ru = _interopRequireDefault(require("./ru"));

var _ja = _interopRequireDefault(require("./ja"));

var _hu = _interopRequireDefault(require("./hu"));

var _pt = _interopRequireDefault(require("./pt"));

var _zh_Hant = _interopRequireDefault(require("./zh_Hant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }